<template>
  <div
    class="column is-12 has-padding-left-10-mobile has-padding-right-20-mobile"
  >
    <div class="is-size-7 columns mb-2 is-mobile is-vcentered">
      <div
        class="column is-narrow mr-3 has-text-weight-bold is-size-6 is-uppercase"
      >
        {{ $t('categories') }}
      </div>
      <hr class="mt-2 mb-2" />
    </div>
    <div v-if="categoryList.length">
      <div v-for="(category, index) in categoryList" :key="index">
        <div
          class="mb-0 is-size-8 pointer"
          :class="{
            'is-active has-text-weight-bold has-text-jobseeker': activeCategory(
              category.slug
            )
          }"
          @click="displayCategoryBlog(category.slug)"
        >
          {{ `${category.name} (${category.count})` }}
          <hr class="mt-2 mb-2" />
        </div>
      </div>
    </div>
    <div v-else class="pl-3">
      <vue-no-data :loading="loading"></vue-no-data>
    </div>
  </div>
</template>
<script>
import VueNoData from '@/components/Commons/VueNoData'
export default {
  components: { VueNoData },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    categoryList() {
      return (
        this.get(this.$store.state.collection.collectionResponses, [
          'BlogCategoryList',
          'categories'
        ]) || []
      )
    }
  },
  mounted() {
    this.getCategory()
  },
  methods: {
    getCategory() {
      this.loading = true
      const contentUrl = `/api/v1/blogs/by-categories/`
      this.$axios
        .get(contentUrl)
        .then(({ data }) => {
          this.$store.commit('collection/setCollectionData', [
            'BlogCategoryList',
            data
          ])
        })
        .finally(() => {
          this.loading = false
        })
    },
    activeCategory(categorySlug) {
      return (
        this.$route.params.slug === categorySlug &&
        [
          `/en/blog/category/${this.$route.params.slug}`,
          `/blog/category/${this.$route.params.slug}`
        ].includes(this.$route.path)
      )
    },
    displayCategoryBlog(slug) {
      this.$router.push(
        this.localePath({
          name: 'blog-category-slug',
          params: { slug }
        })
      )
    }
  }
}
</script>
<style scoped>
.is-size-8 {
  font-size: 0.85rem;
}
</style>
